import { render } from "./NotarizeAct.vue?vue&type=template&id=2d809b4d&scoped=true"
import script from "./NotarizeAct.vue?vue&type=script&lang=js"
export * from "./NotarizeAct.vue?vue&type=script&lang=js"

import "./NotarizeAct.vue?vue&type=style&index=0&id=2d809b4d&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d809b4d"]])

export default __exports__